export const SET_LOADING = "setLoading";
export const SET_ERROR = "setError";
export const SET_AUCTION = "setAuction";
export const SET_TENDERS = "setTenders";
export const SET_INQUIRY = "setInquiry";
export const SET_INQUIRY_PRICE = "setInquiryPrice";